import { userAgent } from './user-agent';

export const isAndroid: boolean = userAgent?.indexOf('android') !== -1;
